// import { html } from 'lit';
// import { __ } from 'i18n';

// export default (el) => {
//     const i18n_invite = __('Invite');
//     const i18n_jid_placeholder = __('user@example.org');
//     const i18n_error_message = __('Please enter a valid XMPP address');
//     const i18n_invite_label = __('XMPP Address');
//     const i18n_reason = __('Optional reason for the invitation');
//     return html`
//         <form class="converse-form" @submit=${(ev) => el.submitInviteForm(ev)}>
//             <fieldset>
//                 <label class="form-label clearfix" for="invitee_jids">${i18n_invite_label}:</label>
//                 ${el.state.get('invalid_invite_jid')
//                     ? html`<div class="error error-feedback">${i18n_error_message}</div>`
//                     : ''}
//                 <converse-autocomplete
//                     .getAutoCompleteList="${() => el.getAutoCompleteList()}"
//                     ?autofocus=${true}
//                     min_chars="1"
//                     position="below"
//                     required="required"
//                     name="invitee_jids"
//                     id="invitee_jids"
//                     placeholder="${i18n_jid_placeholder}"
//                 >
//                 </converse-autocomplete>
//             </fieldset>

//             <fieldset>
//                 <label class="form-label">${i18n_reason}:</label>
//                 <textarea class="form-control" name="reason"></textarea>
//             </fieldset>

//             <fieldset>
//                 <input type="submit" class="btn btn-primary" value="${i18n_invite}" />
//             </fieldset>
//         </form>
//     `;
// };

import { html } from 'lit';
import { __ } from 'i18n';

export default (el) => {
    // Безпечне отримання контактів та обраних
    const allContacts = el.rosterContacts || [];
    const selectedCount = (el.selectedContacts || []).length;

    // Групування контактів по першій літері
    const grouped = allContacts.reduce((groups, contact) => {
        const name = (contact.getDisplayName() || contact.get('jid') || 'Unknown').trim();
        const letter = name[0] ? name[0].toUpperCase() : '#';
        if (!groups[letter]) groups[letter] = [];
        groups[letter].push(contact);
        return groups;
    }, {});

    const sortedLetters = Object.keys(grouped).sort();

    return html`<div class="sonata-muc-invite d-flex flex-column h-100"><div class="p-3 border-bottom border-secondary border-opacity-10"><div class="search-wrapper position-relative"><svg class="search-icon position-absolute top-50 translate-middle-y ms-3" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="8" stroke="#9AB9FF" stroke-width="2"/><path d="M21 21L16.65 16.65" stroke="#9AB9FF" stroke-width="2" stroke-linecap="round"/></svg> <input type="search" class="form-control rounded-pill bg-dark border-0 text-white ps-5" placeholder="${__('Пошук контактів')}" @input="${(ev) => el.onSearch(ev)}" .value="${el.searchQuery || ''}"></div></div><div class="contacts-list flex-grow-1 overflow-auto">${sortedLetters.length === 0
                    ? html`<div class="p-5 text-center text-muted">${__('Контактів не знайдено')}</div>`
                    : ''} ${sortedLetters.map(
                    (letter) => html`<div class="alphabet-separator px-3 py-1 bg-secondary bg-opacity-10 text-muted small fw-bold">${letter}</div>${grouped[letter]
                            .sort((a, b) => a.getDisplayName().localeCompare(b.getDisplayName()))
                            .map((c) => {
                                const jid = c.get('jid');
                                const isSelected = (el.selectedContacts || []).includes(jid);
                                const name = c.getDisplayName();
                                const indicatorStyle = `width: 24px; height: 24px; border-color: ${isSelected ? '#4a76eb' : '#666'} !important; background-color: ${isSelected ? '#4a76eb' : 'transparent'};`;

                                return html`<div class="contact-item d-flex align-items-center justify-content-between p-3 border-bottom border-secondary border-opacity-10" @click="${() => el.toggleContact(jid)}" style="cursor:pointer"><div class="d-flex align-items-center"><converse-avatar .model="${c}" class="avatar me-3" height="40" width="40" name="${name}" style="width:40px;height:40px;--avatar-border-radius:50%"></converse-avatar><div class="overflow-hidden"><div class="text-white text-truncate" style="max-width:250px">${name}</div></div></div><div class="selection-indicator"><div class="rounded-circle border d-flex align-items-center justify-content-center" style="${indicatorStyle}">${isSelected
                                                    ? html`<i class="fa fa-check text-white" style="font-size:10px"></i>`
                                                    : ''}</div></div></div>`;
                            })}`,
                )}</div><div class="p-3 shadow-lg border-top border-secondary border-opacity-10 bg-dark mt-auto"><div class="mb-3" style="height:30px"></div><button class="btn btn-primary w-100 rounded-pill py-3 fw-bold" style="background-color:#4a76eb" ?disabled="${selectedCount === 0 || el._submitting}" @click="${(e) => {
                        e.preventDefault();
                        el.submitInvites();
                    }}">${el._submitting
                        ? html`<span class="spinner-border spinner-border-sm me-2"></span>`
                        : __('Надіслати запрошення')} ${selectedCount > 0 ? `(${selectedCount})` : ''}</button></div></div>`;
};
